import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { clientReportCSV, getAllClients, searchClients, updateArchiveStatus } from "../../api/server";
import AttorneyDashBoardSidebar from "../../layouts/attorneyDashBoardSidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import PaginatedItems from "../dashBoardPages/pagination";
import * as Yup from "yup";
import { ThreeDots } from "react-loader-spinner";
import { useSelector } from "react-redux";
import CustomSearchByDate from "./CustomSearchByDate";
import SetupUserSelect from "../dashBoardPages/SetupUserSelect";
import "./manage-clients.css";
// import NoteForm from "./NoteForm";

const validationSchema = Yup.object({
  search: Yup.string().required("Name/Email is required"),
});

const ArchiveClients = () => {
  const attorney = useSelector((state) => state.user.user.data.firstname);
  const [response, setResponse] = useState();
  const [getloading, setGetLoading] = useState(true);
  const [activeSearch, setActiveSearch] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [dateFilterLoading, setDateFilterLoading] = useState(false);

  const [pageCache, setPageCache] = useState({});
  const [searchCache, setSearchCache] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState();
  // const [notes , setNotes] = useState()
  const checked = ["checked", "Checked", "complete", "Complete"];
  const [csvLoading, setCsvLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [order, setOrder] = useState("ASC");

  // ── NEW: archive selection state ──────────────────────────────────────────
  const [selectedIds, setSelectedIds] = useState([]);
  const [archiveLoading, setArchiveLoading] = useState(false);
  // ─────────────────────────────────────────────────────────────────────────

  const donwloadCSV = async () => {
    const payload = {
      attorneyname: values.attorneyname || "",
      search: values.search || "",
      order: values.order || "DESC",
      ...(startDate && endDate
        ? { date: { start: startDate, end: endDate } }
        : { date: { start: "", end: "" } }),
    };

    setCsvLoading(true);

    try {
      const res = await clientReportCSV(payload);
      console.log("kasdfkjads", res);
      const linkHandler = document.getElementById("csvhandler");
      if (linkHandler && res?.data?.csvLink) {
        linkHandler.setAttribute("href", res.data.csvLink);
        linkHandler.click();
      }

      setCsvLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.error || "CSV download failed");
      setCsvLoading(false);
    }
  };

  // ── NEW: toggle a single userID in/out of selectedIds ────────────────────
  const handleCheckboxChange = (userID) => {
    setSelectedIds((prev) =>
      prev.includes(userID) ? prev.filter((id) => id !== userID) : [...prev, userID]
    );
  };
  // ─────────────────────────────────────────────────────────────────────────

  // ── NEW: send remove-from-archive request ─────────────────────────────────
  const handleRemoveFromArchive = async () => {
    if (selectedIds.length === 0) {
      toast.warn("Please select at least one client to remove from archive.");
      return;
    }

    const payload = {
      archive: 0,
      ids: selectedIds,
    };

    setArchiveLoading(true);
    try {
      const res = await updateArchiveStatus(payload)
      console.log("archive update response", res);
      toast.success("Clients removed from archive successfully.");
      setSelectedIds([]);
      // Bust the page cache so the list refreshes
      setPageCache({});
      setSearchCache({});
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to remove from archive");
    } finally {
      setArchiveLoading(false);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────

  const { handleChange, touched, values, errors, handleSubmit, resetForm, setFieldValue, setFieldTouched } =
    useFormik({
      initialValues: { search: "", attorneyname: attorney, order: "ASC" },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        if (searchCache[pageNo]) {
          const { cachedResponse, cachedTotal } = searchCache[pageNo];
          setResponse(cachedResponse);
          setTotal(cachedTotal);
        } else {
          const finalParams = {
            ...values,
            order: values.order || "ASC",
            date: {
              start: startDate,
              end: endDate,
            },
          };
          setFilterLoading(true);
          setGetLoading(true);
          searchClients(pageNo, finalParams)
            .then((res) => {
              setActiveSearch(true);
              const ungroupData = res.data.result;

              const groupedById = new Map();

              ungroupData.forEach((obj) => {
                if (!groupedById.has(obj.userID)) {
                  groupedById.set(obj.userID, []);
                }
                groupedById.get(obj.userID).push(obj);
              });

              groupedById.forEach((users) => {
                users.sort((a, b) => {
                  if (a.type === "Main" && b.type !== "Main") return -1;
                  if (a.type !== "Main" && b.type === "Main") return 1;
                  return 0;
                });
              });

              const newData = Array.from(groupedById.values());
              const newTotal = res.data.total;
              setSearchCache((prevCache) => ({
                ...prevCache,
                [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
              }));
              setResponse(newData);
              setTotal(newTotal);
              if (pageNo === 1) toast.success("Client search successful");
              setFilterLoading(false);
              setGetLoading(false);
            })
            .catch((err) => {
              toast.error(err.response.data.error);
              setFilterLoading(false);
              setGetLoading(false);
            });
        }
      },
    });

  const handlePageChange = () => {
    if (activeSearch) handleSubmit(values.search);
  };

  const handleClearFilters = () => {
    setFieldValue("search", "");
    setFieldTouched("search", false);
    setActiveSearch(false);
    handleSearchOrDefault({ search: "", order: values.order || "ASC" });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (pageCache[pageNo]) {
        const { cachedResponse, cachedTotal } = pageCache[pageNo];
        setResponse(cachedResponse);
        setTotal(cachedTotal);
      } else {
        setGetLoading(true);
        try {
          // ── archive: 1 is sent here so only archived clients are fetched ──
          const res = await getAllClients(pageNo, { attorneyname: attorney, order: order, archive: true });
          const ungroupData = res.data.result;

          const groupedById = new Map();

          ungroupData.forEach((obj) => {
            if (!groupedById.has(obj.userID)) {
              groupedById.set(obj.userID, []);
            }
            groupedById.get(obj.userID).push(obj);
          });

          groupedById.forEach((users) => {
            users.sort((a, b) => {
              if (a.type === "Main" && b.type !== "Main") return -1;
              if (a.type !== "Main" && b.type === "Main") return 1;
              return 0;
            });
          });

          const newData = Array.from(groupedById.values());
          const newTotal = res.data.total;

          setPageCache((prevCache) => ({
            ...prevCache,
            [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
          }));

          setResponse(newData);
          setTotal(newTotal);
        } catch (err) {
          toast.error(err.response.data.error);
        } finally {
          setGetLoading(false);
        }
      }
    };
    if (!activeSearch) {
      fetchData();
    }
  }, [pageNo, pageCache, order]);

  const handleDateFilterSubmit = (start, end) => {
    setStartDate(start);
    setEndDate(end);

    const cacheKey = `${pageNo}_${values.search || "noSearch"}_${start || "noStart"}_${end || "noEnd"}}`;

    if (searchCache[cacheKey]) {
      const { cachedResponse, cachedTotal } = searchCache[cacheKey];
      setResponse(cachedResponse);
      setTotal(cachedTotal);
    } else {
      setDateFilterLoading(true);
      setGetLoading(true);

      const params = {
        attorneyname: values.attorneyname || "",
        order: values.order || "ASC",
        date: {
          start,
          end,
        },
        search: values.search || "",
      };

      searchClients(pageNo, params)
        .then((res) => {
          const groupedById = {};
          res.data.result.forEach((obj) => {
            if (!groupedById[obj.userID]) {
              groupedById[obj.userID] = [];
            }
            groupedById[obj.userID].push(obj);
          });

          const newData = Object.values(groupedById);
          const newTotal = res.data.total;

          setSearchCache((prevCache) => ({
            ...prevCache,
            [cacheKey]: { cachedResponse: newData, cachedTotal: newTotal },
          }));

          setResponse(newData);
          setTotal(newTotal);
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Date filter failed");
        })
        .finally(() => {
          setDateFilterLoading(false);
          setGetLoading(false);
        });
    }
  };

  const handleSearchOrDefault = (overrides = {}) => {
    const { start, end, ...restOverrides } = overrides;

    const payload = {
      search: values.search,
      attorneyname: values.attorneyname,
      ...restOverrides,
      ...(start && end ? { date: { start, end } } : {}),
    };

    const effectiveStart = overrides.start ?? startDate;
    const effectiveEnd = overrides.end ?? endDate;

    if (effectiveStart && effectiveEnd) {
      payload.date = {
        start: effectiveStart,
        end: effectiveEnd,
      };
    }

    const cacheKey = `${pageNo}_${payload.search}_${payload.attorneyname}_${effectiveStart}_${effectiveEnd}`;

    if (searchCache[cacheKey]) {
      const { cachedResponse, cachedTotal } = searchCache[cacheKey];
      setResponse(cachedResponse);
      setTotal(cachedTotal);
      setActiveSearch(!!payload.search);
    } else {
      setFilterLoading(true);
      setGetLoading(true);

      searchClients(pageNo, payload)
        .then((res) => {
          setActiveSearch(!!payload.search);
          const groupedById = {};
          res.data.result.forEach((obj) => {
            if (!groupedById[obj.userID]) groupedById[obj.userID] = [];
            groupedById[obj.userID].push(obj);
          });

          const newData = Object.values(groupedById);
          const newTotal = res.data.total;

          setSearchCache((prev) => ({
            ...prev,
            [cacheKey]: { cachedResponse: newData, cachedTotal: newTotal },
          }));
          setResponse(newData);
          setTotal(newTotal);
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Search failed");
        })
        .finally(() => {
          setFilterLoading(false);
          setGetLoading(false);
        });
    }
  };

  const handleResetDate = () => {
    setStartDate("");
    setEndDate("");
    handleSearchOrDefault({ start: "", end: "" });
  };

  return (
    <div>
      <a id="csvhandler" target="_blank"></a>
      <div className="wrapper">
        <AttorneyDashBoardSidebar />
        <div id="content" className="attorney-clients-page archived-clients-page">
          <DashboardNavbar />
          {console.log("responseresponse", response)}
          <section className="manage-students">
            <div className="card">
              <div className="card-header">
                {/* <CustomSearchByDate
                  onDateFilter={handleDateFilterSubmit}
                  onReset={handleResetDate}
                  dateFilterLoading={dateFilterLoading}
                /> */}
                <div className="clients-toolbar">
                  <div className="clients-title">
                    <h4 className="card-title">Manage Archived Clients</h4>
                  </div>

                  <div className="clients-tools">
                    {/* <button
                      className="btn_brnd"
                      style={{ padding: "6px 30px", fontWeight: "500" }}
                      type="button"
                      disabled={csvLoading}
                      onClick={() => { donwloadCSV(values); }}
                    >
                      {csvLoading ? (
                        <ThreeDots
                          height="20"
                          width="94"
                          radius="9"
                          color="#4fa94d"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{ display: "block" }}
                          wrapperClassName="spinner"
                          visible={true}
                        />
                      ) : (
                        "Export Data"
                      )}
                    </button> */}

                    {/* ── NEW: Remove from Archive button (shown when any checkbox is ticked) ── */}
                    
                    {/* ────────────────────────────────────────────────────────────────────── */}

                    <form onSubmit={handleSubmit} className="clients-search-form">
                      <div className="clients-sort">
                        <label className="visually-hidden" htmlFor="archived-client-sort-order">Sort archived clients</label>
                        <SetupUserSelect
                          id="archived-client-sort-order"
                          name="order"
                          value={order}
                          onChange={(e) => {
                            const newOrder = e.target.value;
                            setOrder(newOrder);
                            setFieldValue("order", newOrder);
                            setPageCache({});
                            setSearchCache({});
                          }}
                        >
                          <option value="DESC">Descending</option>
                          <option value="ASC">Ascending</option>
                        </SetupUserSelect>
                      </div>
                      {/* <div className="table-search">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          style={{ paddingRight: "35px" }}
                          onChange={handleChange}
                          name="search"
                          value={values.search}
                        />
                        <button
                          disabled={filterLoading || getloading}
                          type="submit"
                          onClick={() => {
                            setPageCache((prevCache) => ({
                              ...prevCache,
                              pageNo: pageNo,
                            }));
                            setPageNo(1);
                            setSearchCache({});
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                        {errors.search && touched.search ? (
                          <p className="text-danger mt-1">{errors.search}</p>
                        ) : null}
                      </div> */}
                    </form>

                    {/* {activeSearch && (
                      <button
                        className="btn_brnd me-3 flex"
                        onClick={handleClearFilters}
                        style={{ float: 'inline-end' }}
                        type="button"
                      >
                        Clear Search
                      </button>
                    )} */}
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="clients-table-scroll" role="region" aria-label="Archived client list" tabIndex={0}>
                <table className="table clients-table">
                  <colgroup><col style={{ width: "27%" }} /><col style={{ width: "35%" }} /><col style={{ width: "14%" }} /><col style={{ width: "14%" }} /><col style={{ width: "10%" }} /></colgroup>
                  <thead>
                    <tr>
                      {/* ── NEW column header ── */}
                      
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Course 1</th>
                      <th scope="col">Course 2</th>
                      <th scope="col">Archive</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getloading ? (
                      <tr>
                        <td colSpan={5}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{ display: "flex", justifyContent: "center" }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : response && response.length > 0 ? (
                      response.map((users, index) =>
                        users.map((user, ind) => (
                          <tr key={index}>
                            {/* ── NEW: checkbox cell — only rendered on the first row of each group (Main user) ── */}
                            {/* {ind === 0 ? (
                              <td
                                rowSpan={users.length}
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedIds.includes(user.userID)}
                                  onChange={() => handleCheckboxChange(user.userID)}
                                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                />
                              </td>
                            ) : null} */}
                            {/* ─────────────────────────────────────────────────────────────────── */}

                            <th
                              scope="row"
                              style={{
                                textTransform: "none",
                                borderBottomWidth: ind !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {user.type === "Joint"
                                ? user.jointFirstName === "" && user.jointLastName === ""
                                  ? user.userFirstName + " " + user.userLastName + "'s Joint"
                                  : user.jointFirstName + " " + user.jointLastName + " (Joint)"
                                : user.userFirstName + " " + user.userLastName}
                            </th>
                            <td
                              style={{
                                textTransform: "none",
                                borderBottomWidth: ind !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {user.userEmail}
                            </td>
                            <td style={{ borderBottomWidth: ind !== users.length - 1 ? "0px" : "" }}>
                              {user.courseFirstId && user.courseFirstGenterated == "yes" ? (
                                user.courseFirstDownloaded && user.courseFirstDownloaded !== "yes" ? (
                                  <a className="text-black" href={user.courseFirstDownloaded} target="_blank">
                                    {user.courseFirstDate ? user.courseFirstDate.split("T")[0] : ""}
                                  </a>
                                ) : user.courseFirstDate ? (
                                  <span className="tooltips">{user.courseFirstDate.split("T")[0]}</span>
                                ) : (
                                  ""
                                )
                              ) : user.courseFirstGenterated == "" && user.perFirstCourse == 100 ? (
                                "Pending"
                              ) : checked.includes(user.activated_first) ? (
                                user.perFirstCourse.toFixed(0) + "%"
                              ) : (
                                "Not Enrolled"
                              )}
                            </td>
                            <td style={{ borderBottomWidth: ind !== users.length - 1 ? "0px" : "" }}>
                              {user.courseSecondId && user.generated == "yes" ? (
                                user.downloaded && user.downloaded !== "yes" ? (
                                  <a className="text-black" href={user.downloaded} target="_blank">
                                    {user.date ? user.date.split("T")[0] : ""}
                                  </a>
                                ) : user.date ? (
                                  <span className="tooltips">{user.date.split("T")[0]}</span>
                                ) : (
                                  ""
                                )
                              ) : user.generated == "" && user.perSecondCourse == 100 ? (
                                "Pending"
                              ) : checked.includes(user.activated_second) ? (
                                user.perSecondCourse.toFixed(0) + "%"
                              ) : (
                                "Not Enrolled"
                              )}
                            </td>
                            {/* {ind === 0 ? ( */}
                              <td
                                // rowSpan={users.length}
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  className="custom_checkbox"
                                  checked={selectedIds.includes(user.userID)}
                                  onChange={() => handleCheckboxChange(user.userID)}
                                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                />
                              </td>
                            {/* ) : null} */}
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={5}>No client found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>
                {!filterLoading && !getloading && total !== 0 && total > 50 && (
                  <PaginatedItems
                    responsive
                    total={total}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    handlePageChange={handlePageChange}
                  />
                )}
                
              </div>
              <div className="clients-archive-actions">
              {selectedIds.length > 0 && (
                      <button
                        className="btn_brnd"
                        style={{ padding: "6px 20px", fontWeight: "500" }}
                        type="button"
                        disabled={archiveLoading}
                        onClick={handleRemoveFromArchive}
                      >
                        {archiveLoading ? (
                          <ThreeDots
                            height="20"
                            width="120"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{ display: "block" }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        ) : (
                          `Remove from Archive`
                        )}
                      </button>
                    )}
                    </div>
            </div>
            
          </section>
        </div>
      </div>
    </div>
  );
};

export default ArchiveClients;
